import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { RouteModule } from '#/horizon/components/RouteModule';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { redirectRequireAuthentication } from '#/modules/auth/routing/redirect-require-authentication';
import { userDashboardApiIsomorphicFetchEvent } from '#/modules/userDashboard/api/userDashboardApiFetchEvent';
import type { userDashboardPreviewEventRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { UserDashboardPreviewEventPageLoadable } from './UserDashboardPreviewEventPageLoadable';

export const handle = {
  darkBackground: true,
  fallbackUrlByLocaleToCurrent: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { eventId },
}: HorizonAppRouteLoaderArgs<typeof userDashboardPreviewEventRoute>) {
  const [{ user }, event] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    userDashboardApiIsomorphicFetchEvent({ request, context })(eventId),
    UserDashboardPreviewEventPageLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });

  return { event };
}

export default function UserDashboardPreviewEventHorizonRoute({
  loaderData: { event },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return (
    <RouteModule title={event.name}>
      <UserDashboardPreviewEventPageLoadable event={event} />
    </RouteModule>
  );
}
